export const DEFAULT_PAGE = 0;
export const DEFAULT_LIMIT = 10;
export const DEFAULT_PROSPECTS_PAGE = 0;
export const DEFAULT_PROSPECTS_LIMIT = 25;
export const MAX_EXCLUDED_COMPANIES_ALLOWED = 1000000;
export const POLL_INTERVAL_MINUTES = 5;
export const ACTIVITY_CODE_PREFIX = "CODE-";
export const GEOGRAPHIC_SEPERATOR = "$@^";
export const SWEDISH_SPECIAL_LETTERS = ["Å", "Ä", "Ö"];
